import React from 'react';
import { motion } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';

const FilterModal = ({ 
  isOpen, 
  onClose, 
  filters, 
  setFilters, 
  uniqueValues,
  onClearFilters 
}) => {
  if (!isOpen) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <motion.div
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.95 }}
        className="bg-white rounded-xl p-6 w-full max-w-md m-4"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-[#080366]">Filters</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <FaTimes />
          </button>
        </div>

        <div className="space-y-4">
          {/* Program Dropdown (1st) */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Program
            </label>
            <select
              value={filters.city}
              onChange={(e) => setFilters({ ...filters, city: e.target.value })}
              className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-[#fbba00] focus:border-transparent"
            >
              <option value="">All Programs</option>
              {uniqueValues.cities.map(city => (
                <option key={city} value={city}>{city}</option>
              ))}
            </select>
          </div>

          {/* Profile Dropdown (2nd) */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Profile
            </label>
            <select
              value={filters.center}
              onChange={(e) => setFilters({ ...filters, center: e.target.value })}
              className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-[#fbba00] focus:border-transparent"
            >
              <option value="">All Profiles</option>
              {uniqueValues.centers.map(center => (
                <option key={center} value={center}>{center}</option>
              ))}
            </select>
          </div>

          {/* Status Dropdown (3rd) */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Status
            </label>
            <select
              value={filters.status}
              onChange={(e) => setFilters({ ...filters, status: e.target.value })}
              className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-[#fbba00] focus:border-transparent"
            >
              <option value="">All Status</option>
              <option value="New">New</option>
              <option value="Hold">Hold</option>
              <option value="Selected">Selected</option>
              <option value="Rejected">Rejected</option>
            </select>
          </div>

          {/* Gender Dropdown (4th) */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Gender
            </label>
            <select
              value={filters.gender}
              onChange={(e) => setFilters({ ...filters, gender: e.target.value })}
              className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-[#fbba00] focus:border-transparent"
            >
              <option value="">All Genders</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
          </div>
        </div>

        <div className="mt-6 flex justify-end space-x-3">
          <button
            onClick={onClearFilters}
            className="px-4 py-2 text-gray-600 hover:text-gray-800"
          >
            Clear All
          </button>
          <button
            onClick={onClose}
            className="px-4 py-2 bg-[#fbba00] text-white rounded-lg hover:bg-[#e5aa00]"
          >
            Apply Filters
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default FilterModal;